module.exports = __webpack_public_path__ + "img/KikoHints.65fc6d71.gif";